<template>
  <BasePage>
    <BodyMes />
    <Footer />
    <!-- <RightNav /> -->
  </BasePage>
</template>
<script>
import BodyMes from "./components/bodyMesage/bodyMes.vue";
import BasePage from "@/components/BasePage/BasePage";
import Footer from "@/components/BasePage/components/Footer/Footer.vue";
import RightNav from "@/components/BasePage/components/RightNav/RightNav.vue";
export default {
  components: {
    BasePage,
    BodyMes,
    RightNav,
    Footer,
  },
  setup() {

    return {

    };
  },
};
</script>
<style></style>